import React, { createContext, useContext } from 'react';

const DashboardFiltersStorageKeyContext = createContext(undefined);

/**
 * When the dashboard is embedded (e.g. BiIntegrated), filter persistence must use the shell
 * settings key (e.g. bis/biIntegrated) so the same filters apply across module-specific
 * dataProviderName values used for APIs (opportunities/lead, opportunities/proposal, …).
 */
export const DashboardFiltersStorageKeyProvider = ({ value, children }) => (
    <DashboardFiltersStorageKeyContext.Provider value={value}>
        {children}
    </DashboardFiltersStorageKeyContext.Provider>
);

export const useDashboardFiltersStorageKey = (moduleDataProviderName) => {
    const fromContext = useContext(DashboardFiltersStorageKeyContext);
    return fromContext ?? moduleDataProviderName;
};
